import request from '@/request'
const state = {
    messages: []
}

const mutations = {
    SET_MESSAGES: (state, messages) => {
        state.messages = messages
    },
    UPDATE_MESSAGES: async (state, message) => {
        state.messages.push(message)
    }
}

const actions = {
    setMessage({ commit }, messages) {
        commit('SET_MESSAGES', messages)
    },
    updateMessage({ commit }, message) {
        commit('UPDATE_MESSAGES', message)
    },
    getMessages({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/roster/get',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getMedia({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/media/stream',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getMessageHistory({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/message_history',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getMessageTemplate({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/user/get_message_template',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    uploadImage({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/media/upload',
                method: 'post',
                data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    pinChat({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: 'roster/pin_chat',
                method: 'post',
                data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })

    },
    sendFirstMessage({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: 'roster/send_first_message',
                method: 'post',
                data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })

    },

}

export default {
    namespaced: true,
    actions,
    mutations,
    state
}